/* unplugin-vue-components disabled */import { render } from "./IncomePermissionBadge.vue?vue&type=template&id=4493f97c&scoped=true"
const script = {}

import "./IncomePermissionBadge.vue?vue&type=style&index=0&id=4493f97c&scoped=true&lang=css"
import "./IncomePermissionBadge.vue?vue&type=style&index=1&id=4493f97c&lang=css"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4493f97c"]])

export default __exports__